export default __webpack_public_path__ + "static/media/euro.icon.c52b5e46.svg";